import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-basic-details-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ 'ConfirmBasicDetails' | translate }}</h2>
    <div mat-dialog-content>
      <p>{{ 'BasicDetailsConfirmationMessage' | translate  }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">
        {{ 'No' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onConfirm()">
        {{ 'Yes' | translate }}
      </button>
    </div>
  `,
})
export class BasicDetailsConfirmDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<BasicDetailsConfirmDialogComponent>
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}

